var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelSpeedUpgrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09426 16.7255C14.6593 10.1605 25.323 10.1605 31.888 16.7255C32.8284 17.6659 34.3543 17.6659 35.2947 16.7255C36.2351 15.7851 36.2351 14.2592 35.2947 13.3188C26.8489 4.89077 13.1334 4.89077 4.7053 13.3366C3.7649 14.277 3.7649 15.8029 4.7053 16.7433C5.64569 17.6837 7.17161 17.6837 8.112 16.7433L8.09426 16.7255ZM14.8899 23.5212C17.7111 20.7 22.2711 20.7 25.0923 23.5212C26.0327 24.4616 27.5586 24.4616 28.499 23.5212C29.4394 22.5808 29.4394 21.0549 28.499 20.1145C23.8148 15.4303 16.2029 15.4303 11.501 20.1145C10.5606 21.0549 10.5606 22.5808 11.501 23.5212C12.4414 24.4616 13.9673 24.4616 14.9077 23.5212H14.8899Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.6618C22.0226 26.6618 23.655 28.2941 23.655 30.3169C23.655 32.3396 22.0226 33.972 19.9999 33.972C17.9772 33.972 16.3448 32.3396 16.3448 30.3169C16.3448 28.2941 17.9772 26.6618 19.9999 26.6618Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39827 33.7616V24.2946C7.39827 23.9185 6.964 24.3039 6.63518 24.5257C6.60278 24.5476 6.57247 24.5722 6.54535 24.6003L4.5127 26.7092M9.30229 24.2604V32.6121C9.30229 32.9882 9.30969 33.7099 9.59722 33.5951C9.62906 33.5824 9.6556 33.5589 9.68009 33.5349L12.1254 31.1396",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelSpeedUpgrade);
export default __webpack_public_path__ + "static/media/paltelSpeedUpgrade.f5b01bdcd1ceb24481c0969bd08b51dd.svg";
export { ForwardRef as ReactComponent };